import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import "@/index.css";
import App from "@/App";

// --- Suppress errors thrown by browser EXTENSIONS (e.g. password managers) ---
// These come from chrome-extension:// / moz-extension:// code, not this app, but
// the dev-server overlay hijacks the screen with them. We silence those only.
const isExtensionError = (s) =>
  typeof s === "string" && (s.includes("chrome-extension://") || s.includes("moz-extension://"));

let extErrorRecent = false;
const removeDevOverlay = () => {
  const el = document.getElementById("webpack-dev-server-client-overlay");
  if (el) el.remove();
};
const markExtError = () => {
  extErrorRecent = true;
  setTimeout(() => { extErrorRecent = false; }, 1500);
  removeDevOverlay();
};

window.addEventListener(
  "error",
  (e) => {
    const src = (e && (e.filename || (e.error && e.error.stack))) || "";
    if (isExtensionError(src)) {
      e.stopImmediatePropagation();
      e.preventDefault();
      markExtError();
    }
  },
  true
);
window.addEventListener(
  "unhandledrejection",
  (e) => {
    const s = (e && e.reason && (e.reason.stack || e.reason.message)) || "";
    if (isExtensionError(s)) {
      e.stopImmediatePropagation();
      e.preventDefault();
      markExtError();
    }
  },
  true
);
if (typeof MutationObserver !== "undefined" && document.body) {
  new MutationObserver(() => {
    if (extErrorRecent) removeDevOverlay();
  }).observe(document.body, { childList: true });
}

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      refetchOnWindowFocus: false,
    },
  },
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </React.StrictMode>,
);
